import { render, staticRenderFns } from "./AgentProfileListingsSold.vue?vue&type=template&id=080aa63a&scoped=true"
import script from "./AgentProfileListingsSold.vue?vue&type=script&lang=ts"
export * from "./AgentProfileListingsSold.vue?vue&type=script&lang=ts"
import style0 from "./AgentProfileListingsSold.vue?vue&type=style&index=0&id=080aa63a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080aa63a",
  null
  
)

export default component.exports